// 获取当前主机的 IP 地址和端口
const config = {
  API_BASE_URL: import.meta.env.PROD 
    ? "https://childseparationanxietyserver.yf-xr.cn"  // 生产环境
    : `http://${window.location.hostname}:3005`         // 开发环境
};

export default config; 